import { render, staticRenderFns } from "./query-account.vue?vue&type=template&id=11808bf5"
import script from "./query-account.vue?vue&type=script&lang=ts"
export * from "./query-account.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports